"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = buildMediaQueriesTags;

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _map2 = _interopRequireDefault(require("lodash/map"));

// eslint-disable-next-line import/prefer-default-export
function buildMediaQueriesTags(breakpoint) {
  var mediaQueries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var forceOWADesktop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if ((0, _isEmpty2["default"])(mediaQueries)) {
    return '';
  }

  var baseMediaQueries = (0, _map2["default"])(mediaQueries, function (mediaQuery, className) {
    return ".".concat(className, " ").concat(mediaQuery);
  });
  var owaQueries = (0, _map2["default"])(baseMediaQueries, function (mq) {
    return "[owa] ".concat(mq);
  });
  return "\n    <style type=\"text/css\">\n      @media only screen and (min-width:".concat(breakpoint, ") {\n        ").concat(baseMediaQueries.join('\n'), "\n      }\n    </style>\n    ").concat(forceOWADesktop ? "<style type=\"text/css\">\n".concat(owaQueries.join('\n'), "\n</style>") : "", "\n  ");
}

module.exports = exports.default;